import { CheckoutAction } from "state/actions/types/checkoutActionsTypes";
import { userError, Checkout } from "types";

export interface CheckoutReducer {
  userErrors: userError[];
  checkout: Checkout;
}

const initialState: CheckoutReducer = {
  userErrors: [],
  checkout: {
    completedAt: null,
    currencyCode: "",
    id: "",
    note: "",
    subtotalPrice: {
      amount: 0
    },
    totalPrice: {
      amount: 0
    },
    webUrl: "",
    lineItems: [],
    totalLineItemsCount: 0
  }
};

export default (
  state: CheckoutReducer = initialState,
  action: CheckoutAction
): CheckoutReducer => {
  switch (action.type) {
    case "FETCH_CHECKOUT_FULFILLED":
    case "CREATE_CHECKOUT_FULFILLED":
    case "UPDATE_LINE_ITEMS_FULFILLED":
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
